'use strict';

angular.module('app')
  .service('Destinations', function($http, $location, $routeParams, $rootScope, Request, config, utils) {
    return {
      getInfo: function(location) {
        return Request.get('places/' + location + '/').then(function(res) {
          return res.data;
        }, function(err) {
          return err;
        });
      },
      getRegions: function(scope) {
        return Request.get('places/' + $routeParams.location + '/regions/').then(function(res) {
          var pins = [];

          _.each(res.data, function(val) {
            pins.push({
              lat: val.latitude,
              lng: val.longitude,
              icon: config.mapIcons.withPrice,
              info: val,
              getMessageScope: function() {
                return scope;
              },
              message: '<div ng-include src=\'"templates/_location_infowindow.html"\'></div>'
            });
          });

          return pins;
        });
      },
      getHighlights: function() {
        return Request.get('places/' + $routeParams.location + '/highlights/').then(function(res) {
          return res.data;
        });
      },
      getClosest: function() {
        return Request.get('places/' + $routeParams.location + '/closest/').then(function(res) {
          return res.data;
        });
      },
      getArticles: function() {
        return Request.get('places/' + $routeParams.location + '/articles/').then(function(res) {
          return res.data;
        });
      },
      suggestEdit: function() {
        return Request.post('places/' + $routeParams.location + '/suggest-edit/').then(function(res) {
          return res.data;
        });
      },
      getFeaturedDeals: function() {
        return Request.get('places/' + $routeParams.location + '/featured-deals/').then(function(res) {
          var preparedData = {
            firstDeal: res.data[0],
            deals: []
          };

          for (var i in res.data) {
            if (i != 0 && i < 5) {
              preparedData.deals.push(res.data[i]);
            }
          }

          return preparedData;
        });
      },
      getMarineLife: function(type, location) {
        if (type) {
          type = type.toLowerCase();
        }

        if (!location) {
          location = $routeParams.location;
        }

        return Request.get('marine-life/' + type + '/' + location + '/').then(function(res) {
          var groups = _.uniq(res.data, 'group.id') || [];

          //Formating array to normal
          _.each(groups, function(obj) {
            _.each(res.data, function(fish) {
              if (obj.group.id === fish.group.id) {
                if (!_.isArray(obj.fishes)) {
                  obj.fishes = [];
                }
                obj.fishes.push(_.clone(fish));
              }
            });

            _.each(obj, function(v, key) {
              if (key === 'fishes') {
                _.each(v, function(fish) {
                  _.each(config.months, function(month) {
                    if (_.isUndefined(obj[month]) || fish[month] > obj[month]) {
                      obj[month] = fish[month];
                    }
                  });
                });
              }
            });
          });

          return groups;
        });
      },
      getShops: function(scope) {
        return Request.get('places/' + $routeParams.location + '/shops/').then(function(res) {
          var liveaboards = 0,
            diveCenters = 0,
            diveResorts = 0,
            firstType = false,
            pins = [],
            operators = {
              lb: [],
              dc: [],
              dr: []
            };

          _.each(res.data, function(val) {
            var url = '';

            val.kind = parseInt(val.kind);

            if (val.kind == 0) {
              operators.dc.push(val);
              url += '/dive-center/';
            } else if (val.kind == 10) {
              operators.lb.push(val);
              url += '/liveaboard/';
            } else {
              operators.dr.push(val);
              url += '/dive-resort/';
            }

            url += val.area + '/' + val.slug + '/';

            if (val.point && val.point.length && val.kind !== 10) {
              pins.push({
                lat: val.point[1],
                lng: val.point[0],
                icon: config.mapIcons.withPrice,
                info: {
                  title: val.title,
                  url: url
                },
                getMessageScope: function() {
                  return scope;
                },
                message: '<div ng-include src=\'"templates/_small_infowindow.html"\'></div>'
              });
            }
          });

          //if (liveaboards != 0) {
          //  firstType = '10';
          //} else if (liveaboards == 0 && diveResorts != 0) {
          //  firstType = '20';
          //} else if (liveaboards == 0 && diveResorts == 0 && diveCenters != 0) {
          //  firstType = '0';
          //}

          return {
            info: operators,
            type: firstType,
            pins: pins
          };
        });
      },
      getShopByKind: function(kind) {
        return Request.get('places/' + $routeParams.location + '/' + kind + '/shops/').then(function(res) {
          return res.data;
        });
      },
      getDiveSites: function(scope) {
        return Request.get('places/' + $routeParams.location + '/dive-sites/').then(function(res) {
          var pins = [];
          _.each(res.data, function(val) {
            if (val.point && val.point.length) {
              pins.push({
                lat: val.point[1],
                lng: val.point[0],
                icon: config.mapIcons.diveSites,
                info: {
                  title: val.title,
                  url: '/dive-site/' + val.area + '/' + val.slug
                },
                getMessageScope: function() {
                  return scope;
                },
                message: '<div ng-include src=\'"templates/_small_infowindow.html"\'></div>'
              });
            }
          });

          return {
            data: res.data,
            pins: pins
          };
        });
      },
      prepareGraphsData: function(data) {
        var prepared = {
          rainfall: [],
          temperature: [],
          waterTemp: []
        };
        _.each(data, function(val) {
          prepared.rainfall.push(parseFloat(val.rainMm));
          prepared.temperature.push(parseFloat(val.avg));

          if (val.waterAvg) {
            prepared.waterTemp.push(parseFloat(val.waterAvg));
          }
        })

        return prepared;
      },
      getAllCountries: function() {
        return Request.get('places/destinations/').then(function(res) {
          var allElements = [],
            data = _.clone(res.data),
            top = [];

          _.each(data, function(val) {
            _.each(val.countries, function(v) {
              allElements.push(v);

              if (v.isTop) {
                top.push(v);
              }
            });
          });

          data.unshift({
            countries: top,
            title: 'Top',
            order: 0
          });

          return {
            data: res.data,
            countriesByGroup: data,
            allElements: allElements
          }
        });
      },
      getUnits: function() {
        // if (!$rootScope.user) {
        //   return {
        //     temperature : 'C',
        //     rainfall : 'mm',
        //     waterClarity : 'm',
        //     waterTemp : 'C'
        //   }
        // }
        return {
          temperature: $rootScope.temperature == 0 ? 'C' : 'F',
          rainfall: $rootScope.distance == 0 ? 'mm' : 'inch',
          waterClarity: $rootScope.distance == 0 ? 'm' : 'feet',
          waterTemp: $rootScope.temperature == 0 ? 'C' : 'F'
        }
      }
    }


  });
